import { STORAGE_KEYS } from "@/shared/constants";
import type { OrganizationSession } from "./types";

const SESSION_KEY = "hope_organization_v1";

export function readOrganizationSession(): OrganizationSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as OrganizationSession;
    if (!parsed?.organization?.id) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeOrganizationSession(session: OrganizationSession): void {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearOrganizationSession(): void {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(STORAGE_KEYS.ACTIVE_ORGANIZATION);
}

export function isOrganizationWorkspaceActive(): boolean {
  try {
    return (
      localStorage.getItem(STORAGE_KEYS.ACTIVE_ORGANIZATION) === "1" &&
      Boolean(readOrganizationSession()?.organization?.id)
    );
  } catch {
    return false;
  }
}

export function setOrganizationWorkspaceActive(active: boolean): void {
  if (active) {
    localStorage.setItem(STORAGE_KEYS.ACTIVE_ORGANIZATION, "1");
    return;
  }
  localStorage.removeItem(STORAGE_KEYS.ACTIVE_ORGANIZATION);
}

export function markOrganizationWelcomeSeen(): void {
  const session = readOrganizationSession();
  if (!session) return;
  writeOrganizationSession({ ...session, needsWelcome: false });
}

export function organizationNeedsWelcome(): boolean {
  return readOrganizationSession()?.needsWelcome === true;
}

/** Impact Cards this organization created — excluded from lobby collect. */
export function getOwnedOrganizationCardIds(): Set<string> {
  const links = readOrganizationSession()?.card_links ?? [];
  return new Set(
    links.filter((link) => link.role === "owner").map((link) => String(link.card_id))
  );
}
